// extracted by mini-css-extract-plugin
export var leftAlign = "_31-2";
export var popper = "_31-0";
export var subtitle = "_31-1";